
//import React from "react";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Slider from "react-slick";
//import "./slick.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SaveTime from "./SaveTime";
import SaveMoney from "./SaveMoney";
import  NewTopPart2 from "./NewTopPart2";
import SaveEnviro from "./SaveEnviro";
import SaveInsurance from "./SaveInsurance";
import AboutFloraPot from "./AboutFloraPot";
import PWForVehicleOwner from "./PWForVehicleOwner";
import PWForTowTruck from "./PWForTowTruck";
import PWForCity from "./PWForCity";
import ContactUs from "./ContactUs";
import Typography from "@material-ui/core/Typography";
import SaveTow from "./SaveTow";
import IntroductionPage from "./IntroductionPage";

import Divider from "@material-ui/core/Divider";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {Link} from "react-router-dom";
import * as MainConstants from "../../utils/MainConstants";
import OrchimaMainPage from "./OrchimaMainPage";
import RequestSample from "./RequestSample";


const styles = theme => ({
    main: {
        width: '100%',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        /*marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            //width: 2000,
            marginLeft: 'auto',
            marginRight: 'auto',
        },*/
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        //margin: theme.spacing.unit,
        minWidth:300,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#e2580d",
        fontSize: theme.typography.pxToRem(10),
        color:"black",
    },

    /*gridList: {
        width: 400,
        height:400,
    },*/
    dividerColor: {
        //marginTop: theme.spacing.unit * 3,
        color:"#e2580d",
        backgroundColor:"#e2580d",
    },
    dividerColorPurpole: {
        //marginTop: theme.spacing.unit * 3,
        height: '20px',
        color:"#ffffff",
        //backgroundColor:"#760eb3",
    },
    dividerColor1: {
        //marginTop: theme.spacing.unit * 3,
        color:"#ddedbb",
        backgroundColor:"#ddedbb",
    },
    switchColor: {
        //marginTop: theme.spacing.unit * 3,
        color:"#e2580d",
        //backgroundColor:"#ddedbb",
    },
    panelheading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    panelsecondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    typoTopMargin: {
        marginTop:'40',
    },
    lowMargin: {
        marginTop:'10',
    },
    grid1Control: {
        fontSize: 12,
        color: 'red',
    },
    /*formControl2: {
        //margin: theme.spacing.unit,
        width: '50%',

    },*/
    formControlLabel: {
        //margin: theme.spacing.unit,
        width: '100%',

    },
    /*
	switchBase: {
		color: deepPurple[300],
		'&$checked': {
			color: deepPurple[500],
		},
		'&$checked + $track': {
			backgroundColor: deepPurple[500],
		},
	},
	*/

});
/*
function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
    className={className}
    style={{ ...style, display: "block", background: "red" }}
    onClick={onClick}
    />
);
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
    className={className}
    style={{ ...style, display: "block", background: "green" }}
    onClick={onClick}
    />
);
}
*/


class SimpleSlider extends Component {




    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const {classes, updateAPolicenoticePath} = this.props;
        const mysettings = {
            dots: true,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical:false,
            arrows:true,
            autoplay:true,


            //    nextArrow: <SampleNextArrow />,
            //prevArrow: <SamplePrevArrow />
        };

        //let tempImageSource = "/static/images/logo3.png";
        //let tempImageSource = "/static/images/FloraPotLogoMine.png";
        //Original color #DA70D6
        let tempImageSource = "/static/images/OrchimaLogo1.png";
        let tempImageSource2 = "/static/images/OrchimaLogo2.png";
        let tempImageSource3 = "/static/images/OrchimaLogo3.png";
        let tempImageSource4 = "/static/images/OrchimaLogo4.png";
        let tempImageSource5 = "/static/images/OrchimaLogo5b.png";
        return (
            <div  style = { {  backgroundColor:"#F2F6F8" ,  marginRight:0, paddingRight:0, paddingTop:10}}>
                {/*<div>*/}
                {/*} <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.3.15/slick.css" />*/}
                {/* <h2> Welcome To PlateWiz&trade;  <img height='40' width='80' src={require('../../images/license2a.png')} /></h2> */}
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <Typography variant="h5" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:40,  marginTop:40}}>
                        <span style = { { textAlign: 'center', alignSelf: 'center' , fontSize:40, color:'black'}}>Welcome To</span> {MainConstants.APPLICATION_NAME}&trade;
                    </Typography>


                </div>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    {/*}
                <Typography variant="h5" component="h5" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#DA70D6', fontSize:32, marginTop:40}}>
                    Where Orchids Flourish, Effortlessly!
                </Typography>*/}

                    {/*} <Typography variant="h5" component="h5" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:32, marginTop:40}}>
                        Where Orchids Thrive in Elegance!
                    </Typography>*/}
                      <Typography variant="h5" component="h5" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:32, marginTop:40}}>
                          Stop Guessing. Start Growing Healthy Orchids.
                    </Typography>

                </div>
                {/*}
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingLeft:20 }}>
                    <img height={240} width={240} src={tempImageSource}   style = { { marginTop:0}}/>
                </div>*/}

                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingLeft:20 }}>
                    <img height={240} width={240} src={tempImageSource2}   style = { { marginTop:0}}/>
                </div>
                {/*}
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingLeft:20 }}>
                    <img height={240} width={240} src={tempImageSource3}   style = { { marginTop:0}}/>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingLeft:20 }}>
                    <img height={240} width={240} src={tempImageSource4}   style = { { marginTop:0}}/>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingLeft:20 }}>
                    <img height={240} width={240} src={tempImageSource5}   style = { { marginTop:0}}/>
                </div> */}

                {/*}
                <Typography variant="h5" component="h2" style = { {  marginTop:20, textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>

                    How many orchids have wilted in your care — and you never knew why?
                </Typography> */}
                <Grid container spacing={2}  style={{flexDirection:"column"}}>

                    <Grid item xs={12} sm={12} md={12} lg={12}  xl={12}>
                        <div id="aboutplatewiz">
                            {/*} <AboutFloraPot> </AboutFloraPot>*/}
                            <OrchimaMainPage> </OrchimaMainPage>
                        </div>
                         <Divider className={classes.dividerColorPurpole}></Divider>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <div  >
                            <RequestSample> </RequestSample>
                           </div>
                    </Grid>
                </Grid>
            </div>
        );
    }

}
SimpleSlider.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleSlider);
//export default SimpleSlider;
